import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  payload: {},
  recentlyViewedLoadComplete: false
};

export default {
  name: "browsingHistory",
  actions: {
    updateBrowsingHistory: payload =>
      dispatch({ type: "UPDATE_BROWSING_HISTORY", payload }),

    fetchBrowsingHistory: async function () {
      await dispatch({ type: "FETCH_BROWSING_HISTORY" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/browsingHistory`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.updateBrowsingHistory(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchBrowsingHistory",
          response.status,
          response.statusText
        );
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_BROWSING_HISTORY":
        return {
          ...state,
          payload: action.payload,
          recentlyViewedLoadComplete: true
        };

      default:
        return state;
    }
  }
};
